import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getAllBlogs } from '../data/blogs';

const FeaturedInsights = () => {
  // Get latest 3 blogs
  const latestBlogs = getAllBlogs().slice(0, 3);
  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Featured Insights & Thought Leadership
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Stay ahead with our latest insights on AI, automation, and digital transformation
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {latestBlogs.map((blog) => (
            <Link
              key={blog.id}
              to={`/insights/${blog.slug}`}
              className="bg-gray-900/50 backdrop-blur-sm rounded-lg overflow-hidden shadow-lg
                hover:shadow-xl transition-all duration-300 flex flex-col
                border border-gray-800/50 hover:bg-gray-900/70 hover:border-teal-400/50 group"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={blog.featuredImage}
                  alt={blog.title}
                  className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-300"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = 'https://images.pexels.com/photos/8386440/pexels-photo-8386440.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080';
                  }}
                />
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <div className="text-sm text-teal-400 font-semibold mb-2">{blog.category}</div>
                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-teal-400 transition-colors">{blog.title}</h3>
                <p className="text-gray-400 mb-4 flex-1 line-clamp-3">{blog.excerpt}</p>
                <div className="text-teal-400 font-medium flex items-center space-x-2 group-hover:text-teal-300">
                  <span>Read More</span>
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedInsights;